import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { WorksheetDto } from '../models/worksheet-dto.interface';

@Injectable({ providedIn: 'root' })
export class WorksheetService {
  private readonly api = inject(ApiService);

  getJobWorksheets(jobId: number): Observable<WorksheetDto[]> {
    return this.api.get(`jobs/${jobId}/worksheets`);
  }
}
